export default __webpack_public_path__ + "static/media/viewProfile.1264d37c.svg";